import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'

import { UnificacaoCadastroView } from './UnificacaoCadastroView'

export default function UnificacaoCadastroRootView() {
  const match = useRouteMatch()

  return (
    <>
      <Breadcrumb title='Unificação de prontuários' />
      <PecSwitch>
        <PrivateRoute
          exact
          path={`${match.url}`}
          component={UnificacaoCadastroView}
          permission={Permissions.gestaoDeCadastros.unificacaoDeCadastros}
        />
      </PecSwitch>
    </>
  )
}
